var map = {
	"./ProgressBar.vue": 63424,
	"./core/Avatar.vue": 69551,
	"./core/Cart/Cart.vue": 67325,
	"./core/Cart/CartHandler.vue": 51711,
	"./core/Cart/MobileCart.vue": 31011,
	"./core/Cart/RecurrentPricesModal.vue": 64920,
	"./core/Cart/partial/CartItem.vue": 89686,
	"./core/Cart/partial/CartItemLoading.vue": 58347,
	"./core/Cart/partial/PromoCodeDiscount.vue": 12884,
	"./core/Cart/partial/PromoCodeValidation.vue": 38749,
	"./core/CopyIcon.vue": 68982,
	"./core/Drawer.vue": 55376,
	"./core/Footer.vue": 50413,
	"./core/FooterMobileNav.vue": 57724,
	"./core/HeaderCard.vue": 15638,
	"./core/HeaderMobile.vue": 40603,
	"./core/IconHeaderCard.vue": 30066,
	"./core/Info/InfoMobile.vue": 81119,
	"./core/Info/InfoSidebar.vue": 16503,
	"./core/Info/components/BalanceBlock.vue": 42779,
	"./core/Info/components/LinkWrapper.vue": 38000,
	"./core/Info/components/MyInstruments.vue": 11218,
	"./core/Info/components/MySponsor.vue": 23325,
	"./core/Info/components/MyTariff.vue": 92932,
	"./core/Info/components/RefLink.vue": 20108,
	"./core/Info/components/UserInfo.vue": 69433,
	"./core/LangSwitcher.vue": 31464,
	"./core/MainMenu.vue": 29855,
	"./core/Modal.vue": 28742,
	"./core/PaymentProcess/Process.vue": 21241,
	"./core/PaymentProcess/ProcessUpgradeTariff.vue": 99761,
	"./core/PaymentProcess/QrCodeDialog.vue": 95262,
	"./core/PaymentProcess/steps/Gateway.vue": 56096,
	"./core/PaymentProcess/steps/Gateways.vue": 39483,
	"./core/PaymentProcess/steps/GatewaysFiat.vue": 81159,
	"./core/PaymentProcess/steps/Step4.vue": 3623,
	"./core/PrimaryMenuMobile.vue": 85285,
	"./core/Profile.vue": 45821,
	"./core/Security/index.vue": 13754,
	"./core/Security/partial/DeactivateTwoFaDialog.vue": 1489,
	"./core/Security/partial/EmailVerificationCode.vue": 80551,
	"./core/Security/partial/LoginHistoryView.vue": 23731,
	"./core/Security/partial/TwoFaDialog.vue": 33257,
	"./core/Security/partial/TwoFaVerification.vue": 74284,
	"./core/Security/partial/TwoFaView.vue": 93904,
	"./core/ShowEditorDescription.vue": 74538,
	"./core/SupportButton.vue": 70645,
	"./core/TeamCount.vue": 23483,
	"./core/UserData.vue": 40326,
	"./core/Warnings.vue": 27907,
	"./core/cards/SmallCard.vue": 70587,
	"./core/layouts/SimpleLayout.vue": 45967,
	"./core/layouts/View.vue": 96177,
	"./core/layouts/ViewAuth.vue": 48114,
	"./core/layouts/ViewCourse.vue": 3888,
	"./core/layouts/ViewUnregistered.vue": 12406,
	"./core/layouts/ViewWidget.vue": 20441,
	"./core/ui/ActionButton.vue": 76118,
	"./core/ui/UBtn.vue": 63335,
	"./helper/BackButton.vue": 41610,
	"./helper/ConfirmDialog.vue": 72851,
	"./helper/Cropper.vue": 32665,
	"./helper/DepositFunds.vue": 38371,
	"./helper/IconCustom.vue": 59610,
	"./helper/Loading.vue": 81476,
	"./helper/MaintenanceMode.vue": 73863,
	"./helper/Notification.vue": 64720,
	"./helper/SuccessAnimation.vue": 6733,
	"./helper/Suspended.vue": 46112,
	"./helper/VersionDialog.vue": 79237,
	"./icons/IconBotManager.vue": 48529,
	"./icons/IconBots.vue": 38188,
	"./icons/IconBtc.vue": 12975,
	"./icons/IconCalc.vue": 99171,
	"./icons/IconInvoice.vue": 24676,
	"./icons/IconMyBots.vue": 52678,
	"./icons/IconPortfolio.vue": 53968,
	"./icons/IconProduct.vue": 28801,
	"./icons/IconProject.vue": 57447,
	"./icons/IconRating.vue": 4090,
	"./icons/IconReceipt.vue": 49854,
	"./icons/IconRefs.vue": 45368,
	"./icons/IconWallet.vue": 35334,
	"./inputs/CustomInput.vue": 26468,
	"./layout/BlockWrapper.vue": 33168,
	"./layout/EmptyWrapper.vue": 12608,
	"./layout/PageWrapper.vue": 5832,
	"./popups/dialogs/BrowserCompatibilityDialog.vue": 90466,
	"./popups/modals/SubscriptionModal.vue": 68367,
	"./widgets/MyDealsWidget.vue": 68723,
	"./widgets/MyFinanceWidget.vue": 94172,
	"./widgets/MyPlansWidget.vue": 86194,
	"./widgets/MyTariffWidget.vue": 37296,
	"./widgets/TeamDealsWidget.vue": 46244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23808;